module.exports = __webpack_public_path__ + "media/bg2.da012e86.mp4";